import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import CircularProgress from '@mui/material/CircularProgress';
import { useForm, FormProvider, Controller } from 'react-hook-form';
import {
  AddressActionButton,
  AddressContent,
  AddressIcon,
  AddressIconBox,
  AddressRoot,
  BackButton,
  BoxCard,
  Form,
  GridRoot,
  NoAddressActionButton
} from './style';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { estados, useGetCepMutation } from '../../../services/cep.service';
import MaskedInput from 'react-text-mask';
import { useTheme } from '@mui/material/styles';
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { useGetMyAddressMutation, useSetMyAddressMutation } from '../../../services/me.service';
import AlertMessage from '../../shared/AlertMessage';

export interface OyanaAdress {
  cep: string;
  zipcode?: string;
  city: string;
  state: string;
  stateOutside?: string;
  address: string;
  neighborhood: string;
  addressNumber: number | string;
  addressComplement: string;
  addressReference: string;
  country?: string;
}

const Address = () => {
  const theme = useTheme();
  const { journeyId, formId, oyanaId } = useParams();
  const [getCepInfo, { data }] = useGetCepMutation();
  const [getOyanaAddressInfo, { data: oyanaAddressData }] = useGetMyAddressMutation();
  const [setOyanaAddressInfo, { isLoading: isLoadingRequest, isError }] = useSetMyAddressMutation();
  const [isLoading, setLoading] = useState<boolean>(false);
  const [isValid, setFormValid] = useState<boolean>(true);
  const [completeAddress, setCompleteAddress] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState('');
  const [valueSelect, setvalueSelect] = useState('');
  const [newAddress, setNewAddress] = useState(false);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    control,
    trigger,
    getValues,
    setValue,
    clearErrors,
    formState: { errors }
  } = useForm<OyanaAdress>();

  const onSubmit = async (submitData: OyanaAdress) => {
    const payload = { id: null, ...submitData };
    setOyanaAddressInfo(payload)
      .unwrap()
      .then(() => {
        navigate(`/responda-anamnese/${formId}/${journeyId}${oyanaId ? `/${oyanaId}` : ''}`);
      })
      .catch(err => {
        setErrorMessage(err.data.message);
      });
  };

  const methods = useForm();
  const stepBack = (e: any) => {
    e.preventDefault();
    if (newAddress) return setNewAddress(false);
    navigate(`/home-anamnese/${formId}/${journeyId}${oyanaId ? `/${oyanaId}` : ''}`);
  };

  const stepForm = (e: any) => {
    e.preventDefault();
    handleSubmit(onSubmit)();
  };
  const stepBackForm = (e: any) => {
    e.preventDefault();
    setNewAddress(true);
  };

  const stepForward = (e: any) => {
    e.preventDefault();
    if (!oyanaAddressData || !oyanaAddressData.address) return;
    setOyanaAddressInfo(oyanaAddressData.address)
      .unwrap()
      .then(resp => {
        navigate(`/responda-anamnese/${formId}/${journeyId}${oyanaId ? `/${oyanaId}` : ''}`);
      })
      .catch(err => {
        setErrorMessage(err.data.message);
      });
  };

  const handlerGetCep = () => {
    const cep = getValues('cep');
    trigger('cep');
    getCepInfo({ cep });
  };

  const handleChangeState = (value: string) => {
    setvalueSelect(value);
  };

  useEffect(() => {
    clearErrors('address');
    clearErrors('neighborhood');
    clearErrors('city');
    clearErrors('state');
    setValue('address', data?.logradouro);
    setValue('neighborhood', data?.bairro);
    setValue('city', data?.localidade);
    if (data?.uf) {
      setValue('state', data.uf);
      setvalueSelect(data.uf);
    }
  }, [data?.bairro, data]);

  useEffect(() => {
    getOyanaAddressInfo({});
  }, []);

  useEffect(() => {
    if (oyanaAddressData) {
      if (oyanaAddressData.needConfirmAddress === false)
        navigate(`/responda-anamnese/${formId}/${journeyId}${oyanaId ? `/${oyanaId}` : ''}`);
      if (oyanaAddressData.address) {
        const objAddress = oyanaAddressData.address;
        const addressString = `${objAddress.address} ${objAddress.addressComplement}, ${objAddress.addressNumber}, ${objAddress.neighborhood}, ${objAddress.city} - ${objAddress.state} , ${objAddress.cep}`;
        setCompleteAddress(addressString);
      }
    }
  }, [oyanaAddressData]);

  return (
    <GridRoot>
      {!oyanaAddressData && (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 10 }}>
            <CircularProgress sx={{ color: 'white' }} />
          </Box>
        </>
      )}

      {oyanaAddressData && (
        <>
          <Box id="form_header"></Box>
          <Box sx={{ padding: 3, minHeight: '161px' }}>
            <Box sx={{ minHeight: '24px' }}>
              <BackButton aria-label="delete" color="primary" onClick={stepBack}>
                <ArrowBackIcon />
              </BackButton>
            </Box>
            <Box mt={6} mb={2}>
              <Box mb={2}>
                <Typography variant="body1" color="neutrals.beige1">
                  Complete seu perfil
                </Typography>
              </Box>
            </Box>
          </Box>
          <BoxCard>
            {((oyanaAddressData.needConfirmAddress && !oyanaAddressData.address) || newAddress) && (
              <>
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 5 }}>
                  <Typography variant="h3">Qual é o seu endereço residencial?</Typography>
                </Box>
                <FormProvider {...methods}>
                  <Form
                    onSubmit={(e: any) => {
                      e.preventDefault();
                    }}
                  >
                    <Box sx={{ mb: 7 }}>
                      <Typography variant="body6" sx={{ mb: 0.5 }}>
                        CEP*
                      </Typography>

                      <Controller
                        name="cep"
                        control={control}
                        rules={{
                          required: 'Campo obrigatório'
                        }}
                        render={() => (
                          <MaskedInput
                            mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
                            className="form-control"
                            guide={false}
                            id="cep"
                            render={(ref, props) => (
                              <TextField
                                {...props}
                                inputRef={ref}
                                id="cep"
                                helperText={errors?.cep?.message}
                                error={errors?.cep && true}
                                type="tel"
                                autoComplete="postal-code"
                                variant="standard"
                                inputProps={{
                                  maxLength: 9,
                                  classes: {
                                    input: 'multilineColor'
                                  },
                                  'data-testid': 'cep'
                                }}
                                fullWidth
                                placeholder="00000-000"
                                {...register('cep', {
                                  onBlur: () => {
                                    handlerGetCep();
                                  },
                                  required: 'Campo Obrigatório'
                                })}
                              />
                            )}
                          />
                        )}
                      />
                    </Box>
                    <Box sx={{ mb: 7 }}>
                      <Typography variant="body6" sx={{ mb: 0.5 }}>
                        Endereço*
                      </Typography>
                      <TextField
                        id="address"
                        helperText={errors?.address?.message}
                        error={errors?.address && true}
                        type="text"
                        autoComplete="address-line1"
                        variant="standard"
                        inputProps={{
                          classes: {
                            input: 'multilineColor'
                          },
                          'data-testid': 'address'
                        }}
                        fullWidth
                        {...register('address', {
                          required: 'Campo Obrigatório'
                        })}
                      />
                    </Box>
                    <Box sx={{ mb: 7 }}>
                      <Typography variant="body6" sx={{ mb: 0.5 }}>
                        Número*
                      </Typography>
                      <TextField
                        id="addressNumber"
                        helperText={errors?.addressNumber?.message}
                        error={errors?.addressNumber && true}
                        type="text"
                        autoComplete="address-line2"
                        variant="standard"
                        inputProps={{
                          classes: {
                            input: 'multilineColor'
                          },
                          'data-testid': 'addressNumber'
                        }}
                        fullWidth
                        {...register('addressNumber', {
                          maxLength: 10,
                          required: 'Campo Obrigatório'
                        })}
                      />
                    </Box>
                    <Box sx={{ mb: 7 }}>
                      <Typography variant="body6" sx={{ mb: 0.5 }}>
                        Complemento
                      </Typography>
                      <TextField
                        id="addressComplement"
                        helperText={errors?.addressComplement?.message}
                        error={errors?.addressComplement && true}
                        type="text"
                        variant="standard"
                        inputProps={{
                          classes: {
                            input: 'multilineColor'
                          },
                          'data-testid': 'addressComplement',
                          maxLength: 100
                        }}
                        fullWidth
                        placeholder="apartamento / casa / quadra"
                        {...register('addressComplement', {
                          maxLength: 100
                        })}
                      />
                    </Box>
                    <Box sx={{ mb: 7 }}>
                      <Typography variant="body6" sx={{ mb: 0.5 }}>
                        Ponto de Referência
                      </Typography>
                      <TextField
                        id="addressReference"
                        helperText={errors?.addressReference?.message}
                        error={errors?.addressReference && true}
                        type="text"
                        variant="standard"
                        inputProps={{
                          classes: {
                            input: 'multilineColor'
                          },
                          'data-testid': 'addressReference'
                        }}
                        fullWidth
                        {...register('addressReference', {
                          maxLength: 60
                        })}
                      />
                    </Box>
                    <Box sx={{ mb: 7 }}>
                      <Typography variant="body6" sx={{ mb: 0.5 }}>
                        Bairro*
                      </Typography>
                      <TextField
                        id="neighborhood"
                        helperText={errors?.neighborhood?.message}
                        error={errors?.neighborhood && true}
                        type="text"
                        autoComplete="address-line3"
                        variant="standard"
                        inputProps={{
                          classes: {
                            input: 'multilineColor'
                          },
                          'data-testid': 'neighborhood'
                        }}
                        fullWidth
                        {...register('neighborhood', {
                          required: 'Campo Obrigatório'
                        })}
                      />
                    </Box>
                    <Box sx={{ mb: 7 }}>
                      <Typography variant="body6" sx={{ mb: 0.5 }}>
                        Cidade*
                      </Typography>
                      <TextField
                        id="city"
                        helperText={errors?.city?.message}
                        error={errors?.city && true}
                        type="text"
                        autoComplete="address-line4"
                        variant="standard"
                        inputProps={{
                          classes: {
                            input: 'multilineColor'
                          },
                          'data-testid': 'city'
                        }}
                        fullWidth
                        {...register('city', {
                          required: 'Campo Obrigatório'
                        })}
                      />
                    </Box>
                    <Box sx={{ mb: 7 }}>
                      <Typography variant="body6" sx={{ mb: 0.5 }}>
                        Estado*
                      </Typography>
                      <Select
                        error={errors?.state && true}
                        id="state"
                        variant="standard"
                        value={valueSelect}
                        fullWidth
                        {...register('state', {
                          onChange: e => handleChangeState(e.target.value),
                          maxLength: 60,
                          required: 'Campo Obrigatório',
                          pattern: {
                            value: /(^[a-zA-Z ]*$)/,
                            message: 'Estado inválido'
                          }
                        })}
                        inputProps={{
                          'data-testid': 'state',
                          MenuProps: {
                            sx: {
                              '&& .Mui-selected': {
                                backgroundColor: theme.palette.neutrals.beige3
                              },
                              '& .MuiMenuItem-root:hover': {
                                backgroundColor: theme.palette.neutrals.beige3
                              }
                            },
                            MenuListProps: {
                              sx: {
                                backgroundColor: theme.palette.neutrals.beige2
                              }
                            }
                          }
                        }}
                      >
                        {estados.map(estado => (
                          <MenuItem key={estado.uf} value={estado.uf}>
                            {estado.nome}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors?.state && <FormHelperText error>{errors?.state?.message}</FormHelperText>}
                    </Box>
                    <AddressActionButton
                      loading={isLoading}
                      fullWidth
                      endIcon={<ArrowForwardIcon />}
                      disabled={!isValid}
                      onClick={stepForm}
                      variant="contained"
                    >
                      Continuar
                    </AddressActionButton>
                  </Form>
                </FormProvider>
              </>
            )}

            {oyanaAddressData.needConfirmAddress && oyanaAddressData.address && !newAddress && (
              <>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Typography variant="h3">Este é o seu endereço residencial?</Typography>
                </Box>
                <Box sx={{ mt: 5 }}>
                  <AddressRoot>
                    <AddressIconBox>
                      <AddressIcon />
                    </AddressIconBox>
                    <AddressContent>
                      <Typography variant="body2R">{completeAddress}</Typography>
                    </AddressContent>
                  </AddressRoot>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <NoAddressActionButton onClick={stepBackForm} variant="contained">
                    Não
                  </NoAddressActionButton>
                  <AddressActionButton
                    fullWidth
                    loading={isLoadingRequest}
                    endIcon={<ArrowForwardIcon />}
                    onClick={stepForward}
                    variant="contained"
                    sx={{ ml: 2 }}
                  >
                    Sim, continuar
                  </AddressActionButton>
                </Box>
              </>
            )}
            {isError && <AlertMessage text={errorMessage} textButton="Tente novamente" type="error" />}
          </BoxCard>
        </>
      )}
    </GridRoot>
  );
};

export default Address;
